import { mapRange } from '@wix/wow-utils';
import { getCssUnits, getMouseTransitionEasing, } from '../../../utils/animationsUtils';
export const name = 'BlobMouse';
export const properties = {
    schema: {},
};
export function animate(_kit, elements, _duration, _delay, { inverted = false, distance = { value: 200, type: 'px' }, scale = 1.4, transitionDuration, transitionEasing = 'linear', } = {}) {
    const element = elements[0];
    const invert = inverted ? -1 : 1;
    if (transitionDuration) {
        element.style.transition = `transform ${transitionDuration}ms ${getMouseTransitionEasing(transitionEasing)}`;
    }
    return {
        progress({ x: progressX, y: progressY }) {
            const translateX = mapRange(0, 1, -distance.value, distance.value, progressX) * invert;
            const translateY = mapRange(0, 1, -distance.value, distance.value, progressY) * invert;
            // if progressX === 0 || progressX === 1, scaleX === scale, if progressX === 0.5, scaleX === 1
            const scaleX = progressX < 0.5
                ? mapRange(0, 0.5, scale, 1, progressX)
                : mapRange(0.5, 1, 1, scale, progressX);
            // if progressY === 0 || progressY === 1, scaleY === scale, if progressY === 0.5, scaleY === 1
            const scaleY = progressY < 0.5
                ? mapRange(0, 0.5, scale, 1, progressY)
                : mapRange(0.5, 1, 1, scale, progressY);
            const units = getCssUnits(distance.type);
            const transform = `translateX(${translateX}${units}) translateY(${translateY}${units}) scale(${scaleX}, ${scaleY}) rotate(var(--comp-rotate-z, 0deg))`;
            element.style.transform = transform;
        },
        kill() {
            element.style.transform = '';
            element.style.transition = '';
        },
    };
}
//# sourceMappingURL=blobMouse.js.map